<template>
  <div
    class="flex items-center bg-block-4 py-4 rounded-xl px-5 gap-3"
  >
    <img :src="icon" alt="" />
    <div
      class="flex flex-col items-start text-white whitespace-nowrap"
    >
      <h1 class="font-bold text-lg">{{ value }}</h1>
      <p class="text-xs">{{ description }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoanInfo",
  props: {
    icon: { type: String },
    value: { type: [String, Number] },
    description: { type: String },
  },
};
</script>
